import { useCallback, useState, useEffect } from 'react';
import styled from 'styled-components';
import {
  AppCard,
  AppInput,
  AppSingleSelect,
} from '@/layout/AppComponents';
import ReactDOMServer from 'react-dom/server';
import Translator from '../../../../components/helpers/Translator';
import colors from '../../../../../constants/colors';
import _ from 'lodash';

export default function ModuleComsaEnvironmentalOfficeNormalEnvironmentalAspectsAcquisitionPhaseCard(
  props
) {
  const {
    values,
    setFieldValue,
    motive,
    environmentalAffection,
    preventiveMeasureOptions,
    noApplyPreventiveMeasures = false,
  } = props;
  const [noApplyText] = useState(
    ReactDOMServer.renderToString(
      <Translator file="module-comsaEnvironmental" name="n.a" />
    )
  );
  const [evaluation, setEvaluation] = useState();
  const [evaluationText] = useState([
    ReactDOMServer.renderToString(
      <Translator file="module-comsaEnvironmental" name="no.applicable" />
    ),
    ReactDOMServer.renderToString(
      <Translator file="module-comsaEnvironmental" name="not-significant" />
    ),
    ReactDOMServer.renderToString(
      <Translator file="module-comsaEnvironmental" name="significant" />
    ),
  ]);
  const [evaluationColor] = useState([
    'text-success',
    'text-warning',
    'text-danger',
  ]);
  const [applicabilityOptions] = useState([
    {
      label: ReactDOMServer.renderToString(
        <Translator file="module-comsaEnvironmental" name="no.applicable" />
      ),
      value: 0,
    },
    {
      label: ReactDOMServer.renderToString(
        <Translator file="module-comsaEnvironmental" name="applicable" />
      ),
      value: 1,
    },
  ]);
  const [controlCapacityOptions] = useState([
    {
      label: ReactDOMServer.renderToString(
        <Translator
          file="module-comsaEnvironmental"
          name="no.control.capacity"
        />
      ),
      value: 0,
    },
    {
      label: ReactDOMServer.renderToString(
        <Translator
          file="module-comsaEnvironmental"
          name="control.capacity.100"
        />
      ),
      value: 1,
    },
  ]);

  useEffect(() => {
    if (values?.applicability !== undefined && values?.applicability !== null) {
      if (values?.applicability === 1) {
        if (
          values?.controlCapacity !== undefined &&
          values?.controlCapacity !== null
        ) {
          if (values?.controlCapacity === 1) {
            if (
              values?.preventiveMeasures !== undefined &&
              values?.preventiveMeasures !== null
            ) {
              setFieldValue(
                'totalScore',
                values?.applicability *
                  values?.controlCapacity *
                  values?.preventiveMeasures +
                  1
              );
              return;
            }
            setFieldValue(
              'totalScore',
              ReactDOMServer.renderToString(
                <Translator
                  file="module-comsaEnvironmental"
                  name="indicate.preventive.measures"
                />
              )
            );
            return;
          }
          setFieldValue(
            'totalScore',
            ReactDOMServer.renderToString(
              <Translator file="module-comsaEnvironmental" name="n.a" />
            )
          );
          return;
        }

        setFieldValue(
          'totalScore',
          ReactDOMServer.renderToString(
            <Translator
              file="module-comsaEnvironmental"
              name="indicate.control.capacity"
            />
          )
        );
        return;
      }
      setFieldValue(
        'totalScore',
        ReactDOMServer.renderToString(
          <Translator file="module-comsaEnvironmental" name="n.a" />
        )
      );
    } else if (values?.totalScore?.props?.name !== 'indicate.applicability') {
      setFieldValue(
        'totalScore',
        ReactDOMServer.renderToString(
          <Translator
            file="module-comsaEnvironmental"
            name="indicate.applicability"
          />
        )
      );
    }
  }, [values]);

  useEffect(() => {
    setEvaluation(
      values?.applicability === 0 || values?.totalScore === noApplyText
        ? 0
        : values?.totalScore < 3
        ? 2
        : _.isNumber(values?.totalScore)
        ? 1
        : undefined
    );
  }, [values]);

  const renderTotalScore = useCallback(
    () =>
      values?.totalScore
        ? _.isNumber(values?.totalScore)
          ? values?.totalScore.toFixed(1)
          : values?.totalScore
        : ' ',
    [values]
  );

  return (
    <Container className="mb-2" bodyClassName="p-1">
      <div className="info-block">
        <div className="line mb-2">
          <div>
            {motive ? (
              <>
                <div>
                  <Translator file="module-comsaEnvironmental" name="reason" />:
                </div>
                <b>{motive}</b>
              </>
            ) : (
              <AppInput
                title={ReactDOMServer.renderToString(
                  <Translator file="module-comsaEnvironmental" name="reason" />
                )}
                value={values?.motive}
                onChange={(opt) => setFieldValue('motive', opt)}
              />
            )}
          </div>
        </div>
        <div className="line mb-2">
          <div>
            <Translator
              file="module-comsaEnvironmental"
              name="environmental.impact"
            />
            :
          </div>
          <div>
            <b>{environmentalAffection}</b>
          </div>
        </div>
      </div>
      <div className="input-block">
        <div className="line">
          <AppSingleSelect
            options={applicabilityOptions}
            title={ReactDOMServer.renderToString(
              <Translator
                file="module-comsaEnvironmental"
                name="applicability"
              />
            )}
            value={values?.applicability}
            onChange={(opt) => setFieldValue('applicability', opt)}
            isClearable
          />
          <AppSingleSelect
            options={controlCapacityOptions}
            title={ReactDOMServer.renderToString(
              <Translator
                file="module-comsaEnvironmental"
                name="control.capacity"
              />
            )}
            value={values?.controlCapacity}
            onChange={(opt) => setFieldValue('controlCapacity', opt)}
            isClearable
          />
        </div>
        <div className="line">
          {noApplyPreventiveMeasures ? (
            <AppInput
              title={ReactDOMServer.renderToString(
                <Translator
                  file="module-comsaEnvironmental"
                  name="preventive.measures"
                />
              )}
              value={ReactDOMServer.renderToString(
                <Translator
                  file="module-comsaEnvironmental"
                  name="not.applicable"
                />
              )}
              readOnly
            />
          ) : (
            <>
              <AppSingleSelect
                options={preventiveMeasureOptions}
                title={ReactDOMServer.renderToString(
                  <Translator
                    file="module-comsaEnvironmental"
                    name="preventive.measures"
                  />
                )}
                value={values?.preventiveMeasures}
                onChange={(opt) => setFieldValue('preventiveMeasures', opt)}
                isClearable
              />
            </>
          )}
        </div>
      </div>
      <div className="score-block">
        <div className="line mb-2">
          <div>
            <Translator file="module-comsaEnvironmental" name="total.score" />:
          </div>
          <div>
            <b>{renderTotalScore()}</b>
          </div>
        </div>
        <div
          className={`line mb-2${
            evaluation !== undefined ? '' : ' no-opacity'
          }`}
        >
          <div>
            <Translator file="module-comsaEnvironmental" name="assessment" />
          </div>
          <div>
            <b className={evaluationColor[evaluation]}>
              {evaluationText[evaluation]}
            </b>
          </div>
        </div>
      </div>
    </Container>
  );
}

const Container = styled(AppCard)`
  .card-body {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
  }
  .info-block,
  .input-block,
  .score-block {
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 0 0.5rem;
  }

  .info-block,
  .score-block {
    text-align: center;
    .line {
      color: ${colors.primaryLight};
      min-height: 42px;
      &.no-opacity {
        opacity: 0;
      }
    }
  }
  .info-block {
    @media (min-width: 1300px) {
      flex-direction: row;
    }
    .line {
      flex: 1 1;
      display: flex;
      flex-direction: column;
      justify-content: center;
    }
  }
  .input-block {
    .line {
      flex-wrap: wrap;

      & > * {
        margin-bottom: 5px;
      }
      @media (min-width: 1300px) {
        display: flex;
        gap: 10px;
        flex-wrap: wrap;
        & > * {
          width: calc(50% - 5px);
          margin-top: 5px;
        }
      }
    }
  }
  .score-block {
    flex-direction: column;
    justify-content: center;
  }
  h3 {
    font-weight: normal;
    color: ${colors.primaryLight};
  }
  h3 {
    font-weight: normal;
    color: ${colors.primaryLight};
  }
  & > div {
    border-right: 1px solid ${colors.grey300};
  }
  h3 {
    font-size: 13px;
    color: $colors.primary;
    margin: 0 0 6px 0;
    font-weight: bold;
  }
  h4 {
    font-size: 10px;
    color: $primary;
    text-transform: uppercase;
  }
`;
